import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '../models/location';
import { ClassSchedule } from '../models/class-schedule';
import { ClassScheduleSession } from '../models/class-schedule-session';
import { DataSharingService } from '../services/data-sharing.service';
import { ClassScheduleService } from '../services/class-schedule.service';
import { ClassMasterService } from '../services/class-master.service';
import { ClassMaster } from '../models/class-master';
import { UserService } from '../services/user.service';
import { StudentGet } from '../models/student-get';
import { StudentService } from '../services/student.service';

@Component({
  selector: 'location-card',
  templateUrl: './location-card.component.html',
  styleUrls: ['./location-card.component.css']
})
export class LocationCardComponent {
  isStudent: boolean = false;
  isRegistered: boolean = false;
  classSchedule: ClassSchedule;
  classScheduleSessions: ClassScheduleSession[];
  classMaster: ClassMaster;
  student: StudentGet = new StudentGet();

  @Input() location: Location; // needed for html data access

  constructor(
    private _router: Router,
    private _dataSerivce: DataSharingService,
    private _classMasterService: ClassMasterService,
    private _classService: ClassScheduleService,
    private _studentService: StudentService,
    private _user: UserService) { }

  register(classSchedule: ClassSchedule) {
    this._dataSerivce.setRegisterProgress('3');
    this._dataSerivce.setSelectedLocation(this.location);
    this._dataSerivce.setSelectedClassSchedule(classSchedule);
    const gotstudent = this._classMasterService.getClassMaster(classSchedule.classMasterId)
      .subscribe(
      res => this.getClassMasterSuccsess(res),
      error => this.getClassMasterFailed(error),
      () => console.log('Get Class Master Complete!'));
  }

  getClassMasterFailed(error: any) {
    const i = '1';
  }

  getMoreDates(locationId: string) {
    // this._classService.getMoreDatesForLocation(locationId)
  }

  getClassMasterSuccsess(result: any) {
    const classMaster = result as ClassMaster;
    this._dataSerivce.setClassMaster(classMaster);
    this.getData();
  }

  getData() {
    const roleId = this._dataSerivce.getRoleId();
    const location = this._dataSerivce.getSelectedLocation();
    const classSchedule = this._dataSerivce.getSelectedClassSchedule();
    const student = this._dataSerivce.getCurrentStudent();
    const classmaster = this._dataSerivce.getClassMaster();
    this.isStudent = (roleId === this._user.roleStudent);

    if (location !== null) {
      this.location = location.location;
    } else {
      this.location = new Location;
    }

    if (classSchedule !== null) {
      this.classSchedule = classSchedule.classSchedule;
      this.classScheduleSessions = classSchedule.classSchedule.classScheduleSessions;
    } else {
      this.classSchedule = new ClassSchedule;
    }

    if (student !== null) {
      this.student = student.student;
    } else {
      this.student = new StudentGet();
    }

    if (classmaster !== null) {
      this.classMaster = classmaster.classmaster;
    } else {
      this.classMaster = new ClassMaster;
    }

    this._studentService.checkStudentEnrollment(this.student.id, this.classSchedule.id)
    .subscribe(
      res => this.checkClassSuccess(res),
      error => this.checkClassFailed(error), 
    () => console.log('addStudentClass Saved!'));

    // this.isRegistered = true;

  }
  checkClassSuccess(result: any) {
    const thisresult = result;
    if (thisresult == 0) {
      this._router.navigate(['/payment']);
    } else {
      this.isRegistered = true;
    }
  }
  checkClassFailed(errors: any) {
    this.isRegistered = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/location-card/location-card.component.ts